import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateHTMLComponent } from "../../templates/template-html/template-html.component";

@Component({
  standalone: true,
  selector: "app-prefix-xdt",
  imports: [TemplateHTMLComponent],
  templateUrl: "./prefix-xdt.component.html",
  styleUrl: "./prefix-xdt.component.less",
})
export class PrefixXdtComponent extends PrefixComponent<string> {
  public constructor() {
    super();
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["xdt"];
  }
}
